import { FieldTitleText, FormControlLayout } from "../AddPatientGroup.style";
import { AddInfoField } from "./AddInfoField";
import * as React from "react";
import { useContext } from "react";
import { ChatInfoContext, useTranslation } from "hhn-commons";
import { IGroupInfo, IInfo, InfoDetails } from "@home-health-notify/domain";

type AddInfoProps = {
  onAddInfoDataChange: (key: string, value: InfoDetails[]) => void;
  addInfoData: IInfo;
  mode: "new" | "edit" | "episode";
  expandFilledAccordion?: boolean;
};
export const AddInfo = ({
  onAddInfoDataChange,
  addInfoData,
  mode,
  expandFilledAccordion,
}: AddInfoProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  const { chat } = useContext(ChatInfoContext);
  const shouldLoadInitialInfo = mode === "edit" || mode === "episode";
  const initialInfoDetails =
    shouldLoadInitialInfo && chat && chat?.chatInfo
      ? (chat?.chatInfo as IGroupInfo).info
      : null;

  // For new mode, if addInfoData has values (from EMR parser), use it as initialInfoDetails
  const getInitialInfo = (fieldName: keyof IInfo): InfoDetails[] => {
    const fieldValue = addInfoData?.[fieldName] ?? [];
    if (mode === "new" && fieldValue.length > 0) {
      return fieldValue;
    }
    return initialInfoDetails?.[fieldName] ?? [];
  };

  return (
    <FormControlLayout>
      <FieldTitleText>{tNs("addInfoTitle")}</FieldTitleText>
      <AddInfoField
        title={tNs("physicianTitle")}
        infoKey="physician"
        onAddInfoDataChange={onAddInfoDataChange}
        infoDetails={addInfoData?.physician ?? []}
        initialInfoDetails={getInitialInfo("physician")}
        isExpanded={expandFilledAccordion && !!addInfoData?.physician?.length}
      />
      <AddInfoField
        title={tNs("careGiverTitle")}
        infoKey="careGiver"
        onAddInfoDataChange={onAddInfoDataChange}
        infoDetails={addInfoData?.careGiver ?? []}
        initialInfoDetails={getInitialInfo("careGiver")}
        isExpanded={expandFilledAccordion && !!addInfoData?.careGiver?.length}
      />
      <AddInfoField
        title={tNs("pharmacyTitle")}
        infoKey="pharmacy"
        onAddInfoDataChange={onAddInfoDataChange}
        infoDetails={addInfoData?.pharmacy ?? []}
        initialInfoDetails={getInitialInfo("pharmacy")}
        isExpanded={expandFilledAccordion && !!addInfoData?.pharmacy?.length}
      />
    </FormControlLayout>
  );
};
